import React from 'react';
import { IncubationTemperature } from './IncubationTemperature';
import './setup.css';
import { SetupTemperature } from './SetupTemperature';

export const ExperimentTempConfig = () => {
  return (
    <div id='experimenttempconfig-wrapper' className="border-box mt-2 ml-1 float-left p-0 experiment-container">
      <label id='experimenttempconfig-label' className="row m-2 font-weight-bold">
        Experiment Temperature Configuration
      </label>
      <SetupTemperature></SetupTemperature>
      <IncubationTemperature></IncubationTemperature>
    </div>
  );
};
